import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { webpushConfig } from 'reactApp/appHelpers/featuresHelpers/features/webPush';
import { safetyPersonalLocalStorage } from 'reactApp/storage';

/**
 * Общие константы и ридер состояния промо-тултипа включения уведомлений.
 * Вынесены отдельно от webPushTooltipCreator, чтобы диагностика (app.webPush.status)
 * не тянула в бандл @mail/3promo и React-компонент промо.
 */
export const WEB_PUSH_PROMO_ID = 'web-push-notify';
export const WEB_PUSH_PROMO_CLOSED_UNTIL_KEY = 'web-push-notify-until';
export const MS_IN_DAY = 24 * 60 * 60 * 1000;

// Ключ 3promo-стора показов/закрытий. 3promo пишет через safetyPersonalLocalStorage
// с паттерном `3promo:<id>`; email-префикс (`<email>|`) добавляет сам storage (keyPattern).
// Итоговый ключ в localStorage: `<email>|3promo:web-push-notify`.
const WEB_PUSH_PROMO_3PROMO_KEY = `3promo:${WEB_PUSH_PROMO_ID}`;

// Фича, включающая промку в 3promo (конвенция `3promo-enable-<promoId>`).
const WEB_PUSH_PROMO_FEATURE = `3promo-enable-${WEB_PUSH_PROMO_ID}`;

/** Состояние промо-тултипа для диагностики: когда следующий показ и покажется ли сейчас. */
export function getWebPushPromoStatus() {
    const { showLimit, closeLimit, intervalAfterCloseDays, intervalAfterSnoozeDays } = webpushConfig.notifyRequestConfig;
    const raw = safetyPersonalLocalStorage.getItem(WEB_PUSH_PROMO_CLOSED_UNTIL_KEY);
    const closedUntil = raw ? Number(raw) : null;
    const snoozed = Boolean(closedUntil && Date.now() < closedUntil);
    // eslint-disable-next-line compat/compat
    const permissionIsDefault = typeof Notification !== 'undefined' && Notification.permission === 'default';
    const apiReady = Boolean(window.__WP?.requestPermission);
    // Включена ли сама промка в 3promo (учитывает cookie-оверрайды, напр. app.disableFeature).
    const featureEnabled = Boolean(isFeature(WEB_PUSH_PROMO_FEATURE));

    return {
        promoId: WEB_PUSH_PROMO_ID,
        // Включена ли промка фичей 3promo-enable-web-push-notify.
        featureEnabled,
        // Когда промо снова сможет показаться (close/snooze откладывают показ).
        nextShowAt: closedUntil ? new Date(closedUntil).toISOString() : null,
        snoozed,
        // Гейт со стороны приложения; showLimit/closeLimit из 3promo-стора здесь не учитываются.
        wouldShowNow: featureEnabled && permissionIsDefault && apiReady && !snoozed,
        permissionIsDefault,
        apiReady,
        config: { showLimit, closeLimit, intervalAfterCloseDays, intervalAfterSnoozeDays },
    };
}

/**
 * Сбросить показ промо-тултипа включения уведомлений: снять closedUntil (snooze/close)
 * и обнулить счётчики show/close 3promo-стора. Нужна перезагрузка страницы — 3promo
 * читает стор один раз на init, in-memory состояние очисткой localStorage не сбрасывается.
 */
export function resetWebPushPromo() {
    safetyPersonalLocalStorage.removeItem(WEB_PUSH_PROMO_CLOSED_UNTIL_KEY);
    safetyPersonalLocalStorage.removeItem(WEB_PUSH_PROMO_3PROMO_KEY);
}
